export default __webpack_public_path__ + "static/media/recruit-design.d35a3e84.svg";